module.exports = __webpack_public_path__ + "img/pavlyukevich.25e5d7b7.png";